import $ from "jquery";

export default function mealPlanner() {
    $(".dropdown-selector").each(function () {
        $(this).children('.dropdown-selector-list')
            .on('show.bs.collapse', () => {
                $(this).addClass('dropdown-selector-open');
            })
            .on('hidden.bs.collapse', () => {
                $(this).removeClass('dropdown-selector-open');
            });
    });
    
    $(".meal-planner").slick({
        slidesToScroll: 1,
        slidesToShow: 1,
    });
}
